import { render, staticRenderFns } from "./ClientOrder.vue?vue&type=template&id=8efb3136&scoped=true"
import script from "./ClientOrder.vue?vue&type=script&lang=js"
export * from "./ClientOrder.vue?vue&type=script&lang=js"
import style0 from "./ClientOrder.vue?vue&type=style&index=0&id=8efb3136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8efb3136",
  null
  
)

export default component.exports